export const addEntry = ({ fieldProps, initialValues }) => {
  const { value, setValue } = fieldProps;
  const newValue = [...value, initialValues];
  setValue(newValue);
};

export const removeEntry = ({ fieldProps, key }) => {
  const { value, setValue } = fieldProps;
  const filteredValue = value.filter(v => v._id !== key);
  setValue(filteredValue);
};

export function getRadioProps(fieldName, getFieldProps) {
  return getFieldProps(fieldName, props => ({
    ...props,
    onChange: isChecked => props.setValue(isChecked),
    onBlur: isChecked => props.setValue(isChecked)
  }));
}

export const whenFieldHasValueHideText = (fieldValue, text) =>
  fieldValue ? '' : text;
